import { createContext, ReactNode } from 'react';
import useThunkReducer, { ThunkDispatch } from 'react-hook-thunk-reducer';

import { initialState, reducer, TAction, TInitialState } from '~/src/entities/speed-bonus/context/reducer';

export type TContextDispatch = ThunkDispatch<TInitialState, TAction>

export type TContext = {
    state: TInitialState,
    dispatch: TContextDispatch,
    debugMode?: boolean,
};

export const Context = createContext<TContext>({
    state: initialState,
    dispatch: () => null,
    debugMode: false,
});

const SpeedBonusConnectionContext = ({ children, debugMode = false }: { children: ReactNode, debugMode?: boolean }): JSX.Element => {
    const [state, dispatch] = useThunkReducer(reducer, initialState);

    debugMode && console.log(state);

    return (
        <Context.Provider value={{ state, dispatch, debugMode }}>
            {children}
        </Context.Provider>
    );
};

export default SpeedBonusConnectionContext;
